import {fetchAuthorized} from "@atg-shared/auth";
import {addAuthHeaders, fetchFileUpload} from "@atg-shared/fetch";
import {TEAM_SERVICE_URL} from "@atg-shared/service-url";

import type {CreateTeamPayload} from "../../domain/team.types";
import type {UploadableFile} from "@atg-ui/avatar";

export type NativeFile = Extract<UploadableFile, {uri: string}>;

export const isNativeFile = (file: unknown): file is NativeFile =>
    Boolean(
        file &&
            typeof file === "object" &&
            "uri" in file &&
            typeof (file as {uri: unknown}).uri === "string",
    );

export const mapToCreateFormData = ({
    name,
    membershipPolicy,
    image,
}: CreateTeamPayload) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("membershipPolicy", membershipPolicy);
    if (image) {
        formData.append("image", image as File);
    }
    return formData;
};

export const mapFormData = (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return formData;
};

export const uploadCreateTeam = (payload: CreateTeamPayload) =>
    fetchAuthorized(
        `${TEAM_SERVICE_URL}/team`,
        {
            method: "POST",
            headers: addAuthHeaders({}),
            body: mapToCreateFormData(payload),
        },
        {},
        fetchFileUpload,
    );

export const uploadTeamImage = (teamId: string, file: UploadableFile) =>
    fetchAuthorized(
        `${TEAM_SERVICE_URL}/${teamId}/images`,
        {
            headers: addAuthHeaders({}),
            body: mapFormData(file as File),
        },
        {},
        fetchFileUpload,
    );
